import React, { useState, useEffect, useRef } from 'react';
import { GrPrevious, GrNext } from "react-icons/gr";
import './HeroSection.css';
import banner from '../images//sliders/kilimambogoslider.jpg'
import malindi1 from '../images/sliders/malindislider.png';
import matuu1 from '../images/sliders/matuuslider.png';
import office from '../images/sliders/officeslider.jpg';


const HeroSection = () => {
    const [currentImage, setCurrentImage] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);

    const images = [
        { src: banner, title: 'Prime, Affordable Land Investments', subtitle: "Discover plots across Kenya's most promising locations." },
        { src: matuu1, title: 'Springview Gardens - Matuu', subtitle: 'Fertile agricultural plots 10 minutes from Matuu Town.' },
        { src: malindi1, title: 'Furaha City - Malindi', subtitle: 'Acre plots in Marereni — ideal for farming and investment.' },
        { src: office, title: 'Office Visits', subtitle: 'Book an office visit to discuss your investment options.' },
    ];

    useEffect(() => {
        // clear any existing timers
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (intervalRef.current) clearInterval(intervalRef.current);

        const startInterval = () => {
            intervalRef.current = setInterval(() => {
                setCurrentImage((prevImage) => (prevImage + 1) % images.length);
            }, 3500);
        };

        if (!isPaused) {
            // small initial timeout so the first transition happens shortly after load
            timeoutRef.current = setTimeout(() => {
                setCurrentImage((prevImage) => (prevImage + 1) % images.length);
                startInterval();
            }, 1500);
        }

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [images.length, isPaused]);

    const nextImage = () => {
        setCurrentImage((currentImage + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentImage((currentImage - 1 + images.length) % images.length);
    };

    const [animateCTA, setAnimateCTA] = useState(false);

    useEffect(() => {
        // trigger CTA entrance animation on slide change
        setAnimateCTA(true);
        const t = setTimeout(() => setAnimateCTA(false), 700);
        return () => clearTimeout(t);
    }, [currentImage]);

    // change to 'outline' to use the outlined CTA style
    const CTA_VARIANT = 'filled';

    return (
        <div className="hero-section">
            <div
                className="carousel-container"
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
            >
                <button onClick={prevImage} className="carousel-button"><GrPrevious /></button>
                <div className="carousel-image-container">
                    {images.map((item, idx) => (
                        <img
                            key={idx}
                            src={item.src}
                            alt={item.title || `Image ${idx + 1}`}
                            className={`carousel-image ${idx === currentImage ? 'active' : ''}`}
                        />
                    ))}
                </div>
                <button onClick={nextImage} className="carousel-button"><GrNext /></button>
                <div className="hero-overlay" />
                <div className="carousel-indicators">
                    {images.map((_, idx) => (
                        <button
                            key={idx}
                            className={`indicator ${idx === currentImage ? 'active' : ''}`}
                            onClick={() => setCurrentImage(idx)}
                            aria-label={`Go to slide ${idx + 1}`}
                        />
                    ))}
                </div>
            </div>
            <div className="hero-cta-wrapper">
                <a
                    href="/Properties"
                    className={`hero-cta ${CTA_VARIANT === 'outline' ? 'outline' : ''} ${animateCTA ? 'enter' : ''}`}
                >
                    Explore Properties
                </a>
            </div>
        </div>
    );
};

export default HeroSection;
